import { render, staticRenderFns } from "./NestableItem.vue?vue&type=template&id=2bb0d247"
import script from "./NestableItem.vue?vue&type=script&lang=js"
export * from "./NestableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports